module.exports = __webpack_public_path__ + "369868975c2f5ad6d19ecd5c1fa9d3b0.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/policies/policies.html
// module id = 1649
// module chunks = 0